import React, {useEffect, useState} from 'react';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {DoubleMemberApi, DoubleMemberImportRecordDto, ImportDoubleMemberModel, PaymentApi, PaymentDto, PaymentStatus, UserApi, UserDto} from '../../scaffold';
import {useAntdTable} from 'ahooks';
import AntDTableUtils from '../../utils/AntDTableUtils';
import {DefaultAntdTableConfig} from '../../utils/CommonConfig';
import {Button, Card, DatePicker, message, Popover, Space, Table} from 'antd';
import moment, {Moment} from 'moment/moment';
import UserViewBtn from '../../components/user/ViewBtn';
import UserEditBtn from '../../components/user/EditBtn';
import {QRCodeSVG} from 'qrcode.react';
import {CSVLink} from 'react-csv';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import Papa from 'papaparse'; // 解析cvs插件 市面上使用较多的
import jschardet from 'jschardet';
import ImportSvcFile from '../../components/ImportSvcFile';
import {parseExcelDate} from '../../utils/ExcelUtils';
import dayjs from 'dayjs';
import Text from 'antd/lib/typography/Text';
import SendDoubleMemberSMSBtn from '../../components/user/sendDoubleMemberSMS'; // 编码识别
export default function ManageDoubleMemberList() {
  const importHook = useOpenApiFpRequest(DoubleMemberApi, DoubleMemberApi.prototype.doubleMemberBatchImportRecordPost);
  const exportHook = useOpenApiFpRequest(DoubleMemberApi, DoubleMemberApi.prototype.doubleMemberExportDoubleMemberPaymentGet);
  const listHook = useOpenApiFpRequest(DoubleMemberApi, DoubleMemberApi.prototype.doubleMemberListAllRecordGet);
  const [formDate, _formDate] = useState<Moment>();

  useEffect(() => {
    listHook.requestSync({});
  }, []);

  useEffect(() => {
    exportHook.requestSync({fromDate: formDate ? formDate.format('YYYY-MM-DD') : undefined});
  }, [formDate]);

  function uploadSvcFile(list: any[]) {
    console.log(list);
    const models: ImportDoubleMemberModel[] = list.map(data => ({
      telephone: data['手机号'] ?? '',
      email: data['邮箱'] ?? '',
      name: data['姓名'] ?? '',
      paidTime: parseExcelDate(data['支付时间']),
      addYear: parseInt(data['续费年限'] ?? '1'),
    }));
    importHook
      .request({batchImportDoubleMemberModel: {models: models}})
      .then(() => {
        console.log('导入成功');
        message.success('导入成功');
      })
      .catch(CommonApiErrorHandler);
    console.log(models);
  }

  return (
    <div className={'p-20'}>
      <Card
        title={'双选会员同步管理'}
        extra={
          <Space>
            <Text>起始时间：</Text>
            <DatePicker value={formDate} onChange={e => _formDate(e as Moment)} style={{width: '100%'}} />
            <CSVLink
              data={
                exportHook.data?.map(i => [
                  i.user?.telephone,
                  i.user?.personalApprove?.email,
                  i.user?.personalApprove?.name,
                  i.user?.personalApprove?.organizationFullTime,
                  i.user?.personalApprove?.levelFullTime,
                  i.user?.personalApprove?.positionFullTime,
                  i.user?.personalApprove?.birthDate,
                  i.paidTime,
                ]) ?? []
              }
              headers={['手机号', '邮箱', '姓名', '单位', '职称', '职务', '出生日期', '支付时间']}
              filename={`双选会员导入模版.csv`}>
              <Button disabled={exportHook.loading} className={'m-r-5'}>
                导出我方缴费记录
              </Button>
            </CSVLink>
            <CSVLink data={[]} headers={['手机号', '邮箱', '姓名', '支付时间', '续费年限']} filename={`双选会员导入模版.csv`}>
              <Button className={'m-r-5'}>下载导入模版</Button>
            </CSVLink>
            <ImportSvcFile loading={importHook.loading} beforeUpload={uploadSvcFile} />
          </Space>
        }>
        <Table dataSource={listHook?.data ?? []} pagination={{showTotal: v => `共 ${v} 条`}} size={'small'} scroll={{x: true}} bordered>
          <Table.Column title={'ID'} dataIndex={'id'} sorter key={'id'} />
          <Table.Column<DoubleMemberImportRecordDto> title={'姓名'} render={(_, i) => i.name} />
          <Table.Column<DoubleMemberImportRecordDto> title={'手机号'} render={(_, i) => i.telephone} />
          <Table.Column<DoubleMemberImportRecordDto> title={'邮箱'} render={(_, i) => i.email} />
          <Table.Column<DoubleMemberImportRecordDto> title={'支付时间'} render={(_, i) => dayjs(i.paidTime).format('YYYY-MM-DD')} />
          <Table.Column<DoubleMemberImportRecordDto> title={'导入时间'} width={180} render={(_, i) => i.createdTime} />
          <Table.Column<DoubleMemberImportRecordDto>
            title={'绑定用户'}
            width={180}
            render={(_, i) =>
              i.user && (
                <UserViewBtn user={i.user} size={'small'} type={'primary'}>
                  查看 {i.user?.memberNo}
                </UserViewBtn>
              )
            }
          />
          <Table.Column<DoubleMemberImportRecordDto> title={'激活时间'} width={180} render={(_, i) => i.registeredTime ?? '未激活'} />
          <Table.Column<DoubleMemberImportRecordDto> title={'缴费年限'} width={80} render={(_, i) => i.addYear} />
          <Table.Column<DoubleMemberImportRecordDto>
            title={'原到期时间'}
            width={100}
            render={(_, i) => i.originalExpireTime && dayjs(i.originalExpireTime).format('YYYY-MM-DD')}
          />
          <Table.Column<DoubleMemberImportRecordDto>
            title={'激活后到期时间'}
            width={120}
            render={(_, i) => i.newExpireTime && dayjs(i.newExpireTime).format('YYYY-MM-DD')}
          />
          <Table.Column<DoubleMemberImportRecordDto>
            title={'操作'}
            width={180}
            render={(_, i) =>
              i.id && (
                <Space>
                  <SendDoubleMemberSMSBtn id={i.id} />
                  <Text>已发 {i.smsCount}</Text>
                </Space>
              )
            }
          />
        </Table>
      </Card>
    </div>
  );
}
